import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.testimonials__slider').forEach(el => {
        const splide = new Splide(el, {
            type:          'loop',
            perPage:       3,
            perMove:       1,
            gap:           '24px',
            pagination:    true,
            arrows:        false,
            autoplay:      true,
            interval:      4500,
            pauseOnHover:  true,
            resetProgress: false,
            autoHeight:    false,
            breakpoints: {
                1024: { perPage: 2 },
                640:  { perPage: 1, gap: '16px' },
            },
        });

        const track = el.querySelector('.splide__track');

        // Lock track height after mount so Splide's internal loop-reset reposition
        // cannot cause a one-frame layout jitter that shifts the progress bar.
        function lockHeight() {
            track.style.height = '';
            requestAnimationFrame(() => {
                track.style.height = track.offsetHeight + 'px';
            });
        }

        splide.on('mounted', lockHeight);
        splide.on('resize',  lockHeight);

        splide.mount();
    });
});
